import call from './index'
//订单列表

export function GyOrderList(data) {
	return call(`admin/order/search`, data, 'get')
}

//订单日志列表
export function getOssMsg() {
	return call(`admin/upload/oss_token`, {})
}

